export const preventCopyProps = (minWidth, backgroundColor) => {
  return {
    onCopy: (e) => e.preventDefault(),
    onCut: (e) => e.preventDefault(),
    onContextMenu: (e) => e.preventDefault(),
    style: {
      userSelect: "none",
      display: "flex",
      flexDirection: "column",
      maxHeight: "85vh",
      minWidth: minWidth,
      backgroundColor: backgroundColor,
    },
  };
};

export const handleKeyDown = (e) => {
  if (
    e.key === "F12" ||
    (e.ctrlKey && e.shiftKey && ["I", "C", "J", "U"].includes(e.key)) ||
    (e.ctrlKey && e.key === "P")
  ) {
    e.preventDefault();
  }
};

export const disablePrint = () => {
  window.onbeforeprint = () => {
    document.body.innerHTML = "";
  };
  window.onafterprint = () => {
    window.location.reload();
  };
};

export const handleBeforePrint = () => {
  document.body.innerHTML = "<h1>Print Bloqueado</h1>";
};

export const handleAfterPrint = () => {
  window.location.reload();
};
